// import React, { useState, useEffect } from "react";
// import {
//     Box,
//     Typography,
//     Table,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell,
//     Paper,
//     Modal,
//     IconButton,
//     Button,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     CircularProgress,
//     FormControl,
//     Select,
//     MenuItem,
//     Chip,
//     Tooltip,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import Swal from "sweetalert2";

// const MaintenanceModal = ({ open, handleClose }) => {
//     const [loading, setLoading] = useState(false);
//     const [maintenanceData, setMaintenanceData] = useState([]);
//     const [editingId, setEditingId] = useState(null);
//     const [editValues, setEditValues] = useState({});

//     const [editForm, setEditForm] = useState({
//         status: "",
//         comment: "",
//     });

//     useEffect(() => {
//         if (open) {
//             fetchMaintenanceData();
//         }
//     }, [open]);

//     const fetchMaintenanceData = async () => {
//         setLoading(true);
//         try {
//             const response = await axios.get(
//                 "Reservation/GetFeedbackList"
//             );
//             if (response.data && response.data.ResultSet) {
//                 setMaintenanceData(response.data.ResultSet);
//             }
//         } catch (error) {
//             console.error("Error fetching maintenance data:", error);
//             Swal.fire({
//                 icon: "error",
//                 title: "Error",
//                 text: "Failed to load maintenance data. Please try again.",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleEdit = (item) => {
//         setEditingId(item.Feed_Id);
//         setEditForm({
//             status: item.Feed_MatStatus || "P",
//             comment: item.Feed_EmpComm || "",
//         });
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setEditForm({
//             ...editForm,
//             [name]: value,
//         });
//     };

//     const handleSave = async (item) => {
//         if (!editForm.status) {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Warning",
//                 text: "Please select a status before saving.",
//             });
//             return;
//         }

//         setLoading(true);
//         try {
//             const response = await axios.get(
//                 `Reservation/AddEMPFeedback?P_MATC_STATUS=${editForm.status}&P_RESERVATION_NO=${item.Res_no}&P_EMP_COMMENT=${editForm.comment}&P_FEEDBACK_ID=${item.Feed_Id}`
//             );

//             if (response.data) {
//                 Swal.fire({
//                     icon: "success",
//                     title: "Success",
//                     text: "Maintenance record updated successfully",
//                     timer: 1500,
//                     showConfirmButton: false,
//                 });
//                 setEditingId(null);
//                 fetchMaintenanceData();
//             }
//         } catch (error) {
//             console.error("Error updating maintenance record:", error);
//             Swal.fire({
//                 icon: "error",
//                 title: "Error",
//                 text: "Failed to update maintenance record. Please try again.",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const cancelEdit = () => {
//         setEditingId(null);
//     };

//     const getBungalowType = (id) => {
//         const types = {
//             "1": "Main Bungalow",
//             "2": "Family Bungalow",
//         };
//         return types[id] || "Unknown";
//     };

//     const getStatusChip = (status) => {
//         const statusMap = {
//             "P": { color: "warning", label: "Pending" },
//             "C": { color: "success", label: "Completed" },
//             "I": { color: "secondary", label: "In Progress" },
//             "D": { color: "primary", label: "Complete Done" },
//         };

//         const { color = "default", label = "Pending" } = statusMap[status] || {};
//         return <Chip label={label} color={color} size="small" />;
//     };

//     return (
//         <Modal open={open} onClose={handleClose}>
//             <Box
//                 sx={{
//                     position: "absolute",
//                     top: "48%",
//                     left: "50%",
//                     transform: "translate(-50%, -50%)",
//                     width: { xs: "95%", sm: "90%", md: "80%" },
//                     maxWidth: "1000px",
//                     bgcolor: "background.paper",
//                     boxShadow: 24,
//                     p: { xs: 2, sm: 3 },
//                     borderRadius: 2,
//                 }}
//             >
//                 <Typography variant="h5" component="h2" sx={{ fontWeight: "500" }}>
//                     Maintenance Management
//                 </Typography>
//                 <IconButton
//                     aria-label="close"
//                     onClick={handleClose}
//                     sx={{
//                         position: "absolute",
//                         top: 8,
//                         right: 8,
//                         color: "black",
//                     }}
//                 >
//                     <CloseIcon />
//                 </IconButton>

//                 <Paper
//                     elevation={5}
//                     sx={{
//                         borderRadius: 2,
//                         width: "100%",
//                         overflow: "auto",
//                         maxHeight: "60vh",
//                         mt: 2,
//                     }}
//                 >
//                     <Box sx={{ minWidth: "50px" }}>
//                         <Table size="small">
//                             <TableHead>
//                                 <TableRow sx={{ backgroundColor: "#1976d2" }}>
//                                     <TableCell
//                                         sx={{
//                                             fontWeight: "bold",
//                                             color: "white",
//                                             borderRight: "1px solid rgba(255, 255, 255, 0.2)",
//                                             textAlign: "center",
//                                             padding: "12px",
//                                             fontSize: "12px"
//                                         }}
//                                     >
//                                         Bungalow Type
//                                     </TableCell>
//                                     <TableCell
//                                         sx={{
//                                             fontWeight: "bold",
//                                             color: "white",
//                                             borderRight: "1px solid rgba(255, 255, 255, 0.2)",
//                                             textAlign: "center",
//                                             padding: "12px",
//                                             fontSize: "12px"
//                                         }}
//                                     >
//                                         Maintenance Report
//                                     </TableCell>
//                                     <TableCell
//                                         sx={{
//                                             fontWeight: "bold",
//                                             color: "white",
//                                             borderRight: "1px solid rgba(255, 255, 255, 0.2)",
//                                             textAlign: "center",
//                                             padding: "12px",
//                                             fontSize: "12px"
//                                         }}
//                                     >
//                                         Status
//                                     </TableCell>
//                                     <TableCell
//                                         sx={{
//                                             fontWeight: "bold",
//                                             color: "white",
//                                             borderRight: "1px solid rgba(255, 255, 255, 0.2)",
//                                             textAlign: "center",
//                                             padding: "12px",
//                                             fontSize: "12px"
//                                         }}
//                                     >
//                                         Employee comment
//                                     </TableCell>
//                                     <TableCell
//                                         sx={{
//                                             fontWeight: "bold",
//                                             color: "white",
//                                             textAlign: "center",
//                                             padding: "12px",
//                                             fontSize: "12px"
//                                         }}
//                                     >
//                                         Actions
//                                     </TableCell>
//                                 </TableRow>
//                             </TableHead>

//                             <TableBody>
//                                 {loading ? (
//                                     <TableRow>
//                                         <TableCell
//                                             colSpan={5}
//                                             sx={{ textAlign: "center", py: 4 }}
//                                         >
//                                             <CircularProgress size={24} />
//                                             <Typography sx={{ ml: 2, display: "inline" }}>
//                                                 Loading...
//                                             </Typography>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : maintenanceData.length === 0 ? (
//                                     <TableRow>
//                                         <TableCell
//                                             colSpan={5}
//                                             sx={{ textAlign: "center", py: 4 }}
//                                         >
//                                             No maintenance records found
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : (
//                                     maintenanceData.map((item, index) => (
//                                         <TableRow
//                                             key={index}
//                                             sx={{
//                                                 "&:hover": { backgroundColor: "#f5f5f5" },
//                                                 backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
//                                             }}
//                                         >
//                                             <TableCell
//                                                 sx={{ textAlign: "center", padding: "12px", fontSize: "12px" }}
//                                             >
//                                                 {getBungalowType(item.Feed_Banglowid)}
//                                             </TableCell>
//                                             <TableCell
//                                                 sx={{ textAlign: "center", padding: "12px", fontSize: "12px" }}
//                                             >
//                                                 {item.Feed_MatReport || "N/A"}
//                                             </TableCell>
//                                             <TableCell
//                                                 sx={{ textAlign: "center", padding: "12px", fontSize: "12px" }}
//                                             >
//                                                 {editingId === item.Feed_Id ? (
//                                                     <FormControl fullWidth size="small">
//                                                         <Select
//                                                             name="status"
//                                                             value={editForm.status || "P"}
//                                                             onChange={handleChange}
//                                                             displayEmpty
//                                                             sx={{
//                                                                 minWidth: "120px",
//                                                                 "& .MuiSelect-select": {
//                                                                     py: 0.8,
//                                                                     fontSize: "12px"
//                                                                 }
//                                                             }}
//                                                         >
//                                                             <MenuItem value="P"><Chip label="Pending" color="warning" size="small" sx={{ mr: 1 }} /></MenuItem>
//                                                             <MenuItem value="I"><Chip label="In Progress" color="secondary" size="small" sx={{ mr: 1 }} /></MenuItem>
//                                                             <MenuItem value="C"><Chip label="Completed" color="success" size="small" sx={{ mr: 1 }} /></MenuItem>
//                                                             <MenuItem value="D"><Chip label="Complete Done" color="primary" size="small" sx={{ mr: 1 }} /> </MenuItem>
//                                                         </Select>
//                                                     </FormControl>
//                                                 ) : (
//                                                     getStatusChip(item.Feed_MatStatus)
//                                                 )}
//                                             </TableCell>
//                                             <TableCell
//                                                 sx={{ textAlign: "center", padding: "12px", fontSize: "12px" }}
//                                             >
//                                                 {editingId === item.Feed_Id ? (
//                                                     <TextField
//                                                         name="comment"
//                                                         value={editForm.comment}
//                                                         onChange={handleChange}
//                                                         variant="outlined"
//                                                         size="small"
//                                                         placeholder="Enter employee comment"
//                                                         sx={{
//                                                             minWidth: "150px",
//                                                             "& .MuiInputBase-input": {
//                                                                 fontSize: "12px",
//                                                                 py: 0.8
//                                                             }
//                                                         }}
//                                                     />
//                                                 ) : (
//                                                     item.Feed_EmpComm || "N/A"
//                                                 )}
//                                             </TableCell>

//                                             <TableCell
//                                                 sx={{ textAlign: "center", padding: "8px", fontSize: "12px" }}
//                                             >
//                                                 {editingId === item.Feed_Id ? (
//                                                     <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
//                                                         <Tooltip title="Save">
//                                                             <IconButton
//                                                                 size="small"
//                                                                 color="primary"
//                                                                 onClick={() => handleSave(item)}
//                                                                 sx={{
//                                                                     backgroundColor: "#e3f2fd",
//                                                                     "&:hover": {
//                                                                         backgroundColor: "#bbdefb",
//                                                                     }
//                                                                 }}
//                                                             >
//                                                                 <SaveIcon fontSize="small" />
//                                                             </IconButton>
//                                                         </Tooltip>
//                                                         <Tooltip title="Cancel">
//                                                             <IconButton
//                                                                 size="small"
//                                                                 color="error"
//                                                                 onClick={cancelEdit}
//                                                                 sx={{
//                                                                     backgroundColor: "#ffebee",
//                                                                     "&:hover": {
//                                                                         backgroundColor: "#ffcdd2",
//                                                                     }
//                                                                 }}
//                                                             >
//                                                                 <CloseIcon fontSize="small" />
//                                                             </IconButton>
//                                                         </Tooltip>
//                                                     </Box>
//                                                 ) : (
//                                                     <Tooltip title="Edit">
//                                                         <IconButton
//                                                             size="small"
//                                                             color="primary"
//                                                             onClick={() => handleEdit(item)}
//                                                             sx={{
//                                                                 backgroundColor: "#e3f2fd",
//                                                                 "&:hover": {
//                                                                     backgroundColor: "#bbdefb",
//                                                                 }
//                                                             }}
//                                                         >
//                                                             <EditIcon fontSize="small" />
//                                                         </IconButton>
//                                                     </Tooltip>
//                                                 )}
//                                             </TableCell>
//                                         </TableRow>
//                                     ))
//                                 )}
//                             </TableBody>
//                         </Table>
//                     </Box>
//                 </Paper>
//                 <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
//                     <Button
//                         variant="contained"
//                         onClick={handleClose}
//                     >
//                         Close
//                     </Button>
//                 </Box>
//             </Box>
//         </Modal>
//     );
// };

// export default MaintenanceModal;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Modal,
//   IconButton,
//   Button,
//   TextField,
//   CircularProgress,
//   FormControl,
//   Select,
//   MenuItem,
//   Chip,
//   Tooltip,
//   Card,
//   CardContent,
//   Grid,
//   Avatar,
//   Link,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
// import HomeIcon from "@mui/icons-material/Home";
// import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import axios from "axios";
// import Swal from "sweetalert2";

// const ReadMoreText = ({ text, wordLimit = 20 }) => {
//   const [isExpanded, setIsExpanded] = useState(false);

//   if (!text) return "N/A";

//   const words = text.split(" ");

//   if (words.length <= wordLimit) {
//     return text;
//   }

//   const toggleExpand = (e) => {
//     e.preventDefault();
//     setIsExpanded(!isExpanded);
//   };

//   return isExpanded ? (
//     <span>
//       {text}{" "}
//       <Link
//         href="#"
//         onClick={toggleExpand}
//         sx={{
//           color: "#1976d2",
//           fontSize: "11px",
//           fontWeight: 500,
//           ml: 0.5,
//         }}
//       >
//         See less
//       </Link>
//     </span>
//   ) : (
//     <span>
//       {words.slice(0, wordLimit).join(" ")}{" "}
//       <Link
//         href="#"
//         onClick={toggleExpand}
//         sx={{
//           color: "#1976d2",
//           fontSize: "11px",
//           fontWeight: 500,
//           ml: 0.5,
//         }}
//       >
//         See more
//       </Link>
//     </span>
//   );
// };

// const MaintenanceModal = ({ open, handleClose }) => {
//   const [loading, setLoading] = useState(false);
//   const [maintenanceData, setMaintenanceData] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editForm, setEditForm] = useState({
//     status: "",
//     comment: "",
//   });
//   const [selectedBungalowType, setSelectedBungalowType] = useState(null);
//   const [filteredData, setFilteredData] = useState([]);

//   useEffect(() => {
//     if (open) {
//       fetchMaintenanceData();
//     } else {
//       setSelectedBungalowType(null);
//     }
//   }, [open]);

//   const fetchMaintenanceData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get("Reservation/GetFeedbackList");
//       if (response.data && response.data.ResultSet) {
//         setMaintenanceData(response.data.ResultSet);
//       }
//     } catch (error) {
//       console.error("Error fetching maintenance data:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load maintenance data. Please try again.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBungalowSelect = (typeId) => {
//     setSelectedBungalowType(typeId);
//     const filtered = maintenanceData.filter(
//       (item) => item.Feed_Banglowid == typeId
//     );
//     setFilteredData(filtered);
//   };

//   const handleBackToSelection = () => {
//     setSelectedBungalowType(null);
//   };

//   const handleEdit = (item) => {
//     setEditingId(item.Feed_Id);
//     setEditForm({
//       status: item.Feed_MatStatus || "P",
//       comment: item.Feed_EmpComm || "",
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm({
//       ...editForm,
//       [name]: value,
//     });
//   };

//   const handleSave = async (item) => {
//     if (!editForm.status) {
//       Swal.fire({
//         icon: "warning",
//         title: "Warning",
//         text: "Please select a status before saving.",
//       });
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `Reservation/AddEMPFeedback?P_MATC_STATUS=${editForm.status}&P_RESERVATION_NO=${item.Res_no}&P_EMP_COMMENT=${editForm.comment}&P_FEEDBACK_ID=${item.Feed_Id}`
//       );

//       if (response.data) {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "Maintenance record updated successfully",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         setEditingId(null);
//         fetchMaintenanceData();

//         const filtered = maintenanceData.filter(
//           (item) => item.Feed_Banglowid == selectedBungalowType
//         );
//         setFilteredData(filtered);
//       }
//     } catch (error) {
//       console.error("Error updating maintenance record:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to update maintenance record. Please try again.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const cancelEdit = () => {
//     setEditingId(null);
//   };

//   const getStatusChip = (status) => {
//     const statusMap = {
//       P: { color: "warning", label: "Pending" },
//       C: { color: "success", label: "Completed" },
//       I: { color: "secondary", label: "In Progress" },
//       D: { color: "primary", label: "Complete Done" },
//     };

//     const { color = "default", label = "Pending" } = statusMap[status] || {};
//     return <Chip label={label} color={color} size="small" />;
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box
//         sx={{
//           position: "absolute",
//           top: "48%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: { xs: "95%", sm: "90%", md: "80%" },
//           maxWidth: "1000px",
//           bgcolor: "background.paper",
//           boxShadow: 24,
//           p: { xs: 2, sm: 3 },
//           borderRadius: 2,
//         }}
//       >
//         <Typography variant="h5" component="h2" sx={{ fontWeight: "500" }}>
//           Maintenance Management
//         </Typography>
//         <IconButton
//           aria-label="close"
//           onClick={handleClose}
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: 8,
//             color: "black",
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         {!selectedBungalowType ? (
//           <Box sx={{ mt: 4 }}>
//             <Typography
//               variant="h6"
//               sx={{ mb: 3, textAlign: "center", color: "#555" }}
//             >
//               Select Bungalow Type to View Maintenance
//             </Typography>
//             <Grid container spacing={3} justifyContent="center">
//               <Grid item xs={6} sm={6}>
//                 <Card
//                   sx={{
//                     cursor: "pointer",
//                     borderRadius: 3,
//                     transition: "all 0.3s ease",
//                     background:
//                       "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
//                     },
//                   }}
//                   onClick={() => handleBungalowSelect("1")}
//                 >
//                   <CardContent sx={{ textAlign: "center", py: 4, px: 3 }}>
//                     <Avatar
//                       sx={{
//                         width: 60,
//                         height: 60,
//                         margin: "0 auto 15px",
//                         bgcolor: "#3f51b5",
//                       }}
//                     >
//                       <HomeIcon fontSize="large" />
//                     </Avatar>
//                     <Typography
//                       variant="h6"
//                       sx={{ mb: 1, fontWeight: 600, color: "#333" }}
//                     >
//                       Main Bungalow
//                     </Typography>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       sx={{
//                         mt: 1,
//                         borderRadius: 20,
//                         textTransform: "none",
//                         borderColor: "#3f51b5",
//                         color: "#3f51b5",
//                         "&:hover": {
//                           backgroundColor: "#3f51b5",
//                           color: "#fff",
//                         },
//                       }}
//                     >
//                       View Maintenance
//                     </Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//               <Grid item xs={6} sm={6}>
//                 <Card
//                   sx={{
//                     cursor: "pointer",
//                     borderRadius: 3,
//                     transition: "all 0.3s ease",
//                     background:
//                       "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//                     "&:hover": {
//                       transform: "translateY(-5px)",
//                       boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
//                     },
//                   }}
//                   onClick={() => handleBungalowSelect("2")}
//                 >
//                   <CardContent sx={{ textAlign: "center", py: 4, px: 3 }}>
//                     <Avatar
//                       sx={{
//                         width: 60,
//                         height: 60,
//                         margin: "0 auto 15px",
//                         bgcolor: "#e91e63",
//                       }}
//                     >
//                       <FamilyRestroomIcon fontSize="large" />
//                     </Avatar>
//                     <Typography
//                       variant="h6"
//                       sx={{ mb: 1, fontWeight: 600, color: "#333" }}
//                     >
//                       Family Bungalow
//                     </Typography>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       sx={{
//                         mt: 1,
//                         borderRadius: 20,
//                         textTransform: "none",
//                         borderColor: "#e91e63",
//                         color: "#e91e63",
//                         "&:hover": {
//                           backgroundColor: "#e91e63",
//                           color: "#fff",
//                         },
//                       }}
//                     >
//                       View Maintenance
//                     </Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//             <Typography
//               variant="caption"
//               display="block"
//               sx={{ mt: 3, textAlign: "center", color: "#888" }}
//             >
//               Click on a bungalow type to view and manage maintenance requests
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             <Button
//               onClick={handleBackToSelection}
//               sx={{ mt: 1, mb: 2 }}
//               startIcon={<ArrowBackIcon />}
//               color="primary"
//             >
//               Back to Bungalow Selection
//             </Button>

//             <Typography variant="h6" sx={{ mb: 2, color: "#444" }}>
//               {selectedBungalowType === "1"
//                 ? "Main Bungalow"
//                 : "Family Bungalow"}{" "}
//               Maintenance
//             </Typography>

//             <Paper
//               elevation={5}
//               sx={{
//                 borderRadius: 2,
//                 width: "100%",
//                 overflow: "auto",
//                 maxHeight: "60vh",
//                 mt: 1,
//               }}
//             >
//               <Box sx={{ minWidth: "50px" }}>
//                 <Table size="small">
//                   <TableHead>
//                     <TableRow
//                       sx={{
//                         backgroundColor: "#1976d2",
//                         "& th": {
//                           fontWeight: "bold",
//                           color: "white",
//                           borderRight: "1px solid rgba(255, 255, 255, 0.2)",
//                           textAlign: "center",
//                           padding: "12px",
//                           fontSize: "12px",
//                         },
//                       }}
//                     >
//                       <TableCell>Maintenance Report</TableCell>
//                       <TableCell>Status</TableCell>
//                       <TableCell>Employee comment</TableCell>
//                       <TableCell>Actions</TableCell>
//                     </TableRow>
//                   </TableHead>

//                   <TableBody>
//                     {loading ? (
//                       <TableRow>
//                         <TableCell
//                           colSpan={4}
//                           sx={{ textAlign: "center", py: 4 }}
//                         >
//                           <CircularProgress size={24} />
//                           <Typography sx={{ ml: 2, display: "inline" }}>
//                             Loading...
//                           </Typography>
//                         </TableCell>
//                       </TableRow>
//                     ) : filteredData.length === 0 ? (
//                       <TableRow>
//                         <TableCell
//                           colSpan={4}
//                           sx={{ textAlign: "center", py: 4, color: "#666" }}
//                         >
//                           No maintenance records found for this bungalow type
//                         </TableCell>
//                       </TableRow>
//                     ) : (
//                       filteredData.map((item, index) => (
//                         <TableRow
//                           key={index}
//                           sx={{
//                             "&:hover": { backgroundColor: "#f5f5f5" },
//                             backgroundColor:
//                               index % 2 === 0 ? "#fafafa" : "white",
//                           }}
//                         >
//                           <TableCell
//                             sx={{
//                               textAlign: "left",
//                               padding: "12px",
//                               fontSize: "12px",
//                             }}
//                           >
//                             <ReadMoreText
//                               text={item.Feed_MatReport || "N/A"}
//                               wordLimit={4}
//                             />
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               textAlign: "center",
//                               padding: "12px",
//                               fontSize: "12px",
//                             }}
//                           >
//                             {editingId === item.Feed_Id ? (
//                               <FormControl fullWidth size="small">
//                                 <Select
//                                   name="status"
//                                   value={editForm.status || "P"}
//                                   onChange={handleChange}
//                                   displayEmpty
//                                   sx={{
//                                     minWidth: "120px",
//                                     "& .MuiSelect-select": {
//                                       py: 0.8,
//                                       fontSize: "12px",
//                                     },
//                                   }}
//                                 >
//                                   <MenuItem value="C">
//                                     <Chip
//                                       label="Completed"
//                                       color="success"
//                                       size="small"
//                                       sx={{ mr: 1 }}
//                                     />
//                                   </MenuItem>
//                                   <MenuItem value="D">
//                                     <Chip
//                                       label="Complete Done"
//                                       color="primary"
//                                       size="small"
//                                       sx={{ mr: 1 }}
//                                     />{" "}
//                                   </MenuItem>
//                                 </Select>
//                               </FormControl>
//                             ) : (
//                               getStatusChip(item.Feed_MatStatus)
//                             )}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               textAlign: "left",
//                               padding: "12px",
//                               fontSize: "12px",
//                             }}
//                           >
//                             {editingId === item.Feed_Id ? (
//                               <TextField
//                                 name="comment"
//                                 value={editForm.comment}
//                                 onChange={handleChange}
//                                 variant="outlined"
//                                 size="small"
//                                 placeholder="Enter employee comment"
//                                 sx={{
//                                   minWidth: "150px",
//                                   "& .MuiInputBase-input": {
//                                     fontSize: "12px",
//                                     py: 0.8,
//                                   },
//                                 }}
//                               />
//                             ) : (
//                               <ReadMoreText
//                                 text={item.Feed_EmpComm || "N/A"}
//                                 wordLimit={20}
//                               />
//                             )}
//                           </TableCell>

//                           <TableCell
//                             sx={{
//                               textAlign: "center",
//                               padding: "8px",
//                               fontSize: "12px",
//                             }}
//                           >
//                             {editingId === item.Feed_Id ? (
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   gap: 1,
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <Tooltip title="Save">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() => handleSave(item)}
//                                     sx={{
//                                       backgroundColor: "#e3f2fd",
//                                       "&:hover": {
//                                         backgroundColor: "#bbdefb",
//                                       },
//                                     }}
//                                   >
//                                     <SaveIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Cancel">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={cancelEdit}
//                                     sx={{
//                                       backgroundColor: "#ffebee",
//                                       "&:hover": {
//                                         backgroundColor: "#ffcdd2",
//                                       },
//                                     }}
//                                   >
//                                     <CloseIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </Box>
//                             ) : (
//                               <Tooltip title="Edit">
//                                 <IconButton
//                                   size="small"
//                                   color="primary"
//                                   onClick={() => handleEdit(item)}
//                                   sx={{
//                                     backgroundColor: "#e3f2fd",
//                                     "&:hover": {
//                                       backgroundColor: "#bbdefb",
//                                     },
//                                   }}
//                                 >
//                                   <EditIcon fontSize="small" />
//                                 </IconButton>
//                               </Tooltip>
//                             )}
//                           </TableCell>
//                         </TableRow>
//                       ))
//                     )}
//                   </TableBody>
//                 </Table>
//               </Box>
//             </Paper>
//             <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
//               <Button
//                 variant="contained"
//                 onClick={handleClose}
//                 sx={{
//                   borderRadius: 2,
//                   px: 3,
//                   py: 1,
//                   textTransform: "none",
//                   fontWeight: 500,
//                 }}
//               >
//                 Close
//               </Button>
//             </Box>
//           </>
//         )}
//       </Box>
//     </Modal>
//   );
// };

// export default MaintenanceModal;



import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Modal,
  IconButton,
  Button,
  TextField,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Tooltip,
  Card,
  CardContent,
  Grid,
  Avatar,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BuildIcon from "@mui/icons-material/Build";
import axios from "axios";
import Swal from "sweetalert2";

const MAINTENANCE_RESERVATION_NO = 0;
const INITIAL_MAINTENANCE_STATUS = "P";

const ReadMoreText = ({ text, wordLimit = 20 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return "N/A";

  const words = text.split(" ");

  if (words.length <= wordLimit) {
    return text;
  }

  const toggleExpand = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  return isExpanded ? (
    <span>
      {text}{" "}
      <Link
        href="#"
        onClick={toggleExpand}
        sx={{
          color: "#1976d2",
          fontSize: "11px",
          fontWeight: 500,
          ml: 0.5,
        }}
      >
        See less
      </Link>
    </span>
  ) : (
    <span>
      {words.slice(0, wordLimit).join(" ")}{" "}
      <Link
        href="#"
        onClick={toggleExpand}
        sx={{
          color: "#1976d2",
          fontSize: "11px",
          fontWeight: 500,
          ml: 0.5,
        }}
      >
        See more
      </Link>
    </span>
  );
};

const MaintenanceModal = ({ open, handleClose, showReportForm = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [maintenanceData, setMaintenanceData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [maintenanceReport, setMaintenanceReport] = useState("");
  const [isAddingReport, setIsAddingReport] = useState(false);
  const [editForm, setEditForm] = useState({
    status: "",
    comment: "",
  });
  const [selectedBungalowType, setSelectedBungalowType] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (open) {
      fetchMaintenanceData();
    } else {
      setSelectedBungalowType(null);
    }
  }, [open]);

  const fetchMaintenanceData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("Reservation/GetFeedbackList");
      if (response.data && Array.isArray(response.data.ResultSet)) {
        setMaintenanceData(response.data.ResultSet);
        return response.data.ResultSet;
      }
      throw new Error("Maintenance list response did not contain a result set.");
    } catch (error) {
      console.error("Error fetching maintenance data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load maintenance data. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddMaintenanceReport = async () => {
    const report = maintenanceReport.trim();
    if (!report) {
      Swal.fire({
        icon: "warning",
        title: "Report Required",
        text: "Please enter a maintenance report before submitting.",
      });
      return;
    }

    setIsAddingReport(true);
    try {
      const params = new URLSearchParams({
        P_RESERVATION_NO: String(MAINTENANCE_RESERVATION_NO),
        P_MATC_REPORT: report,
        P_MATC_STATUS: INITIAL_MAINTENANCE_STATUS,
      });
      const response = await axios.get(`Reservation/AddFeedback?${params}`);
      if (
        !response.data ||
        (response.data.StatusCode !== undefined && response.data.StatusCode !== 200)
      ) {
        throw new Error(
          response.data?.Message || "Failed to add maintenance report."
        );
      }

      setMaintenanceReport("");
      const refreshedData = await fetchMaintenanceData();
      if (refreshedData && selectedBungalowType) {
        setFilteredData(
          refreshedData.filter(
            (record) => String(record.Feed_Banglowid) === selectedBungalowType
          )
        );
      }
      Swal.fire({
        icon: "success",
        title: "Report Added",
        text: "The maintenance report was added successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error adding maintenance report:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add maintenance report. Please try again.",
      });
    } finally {
      setIsAddingReport(false);
    }
  };

  const handleBungalowSelect = (typeId) => {
    setSelectedBungalowType(typeId);
    const filtered = maintenanceData.filter(
      (item) => String(item.Feed_Banglowid) === typeId
    );
    setFilteredData(filtered);
  };

  const handleBackToSelection = () => {
    setSelectedBungalowType(null);
  };

  const handleEdit = (item) => {
    setEditingId(item.Feed_Id);
    setEditForm({
      status: item.Feed_MatStatus || "P",
      comment: item.Feed_EmpComm || "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditForm({
      ...editForm,
      [name]: value,
    });
  };

  const handleSave = async (item) => {
    if (!editForm.status) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select a status before saving.",
      });
      return;
    }

    setLoading(true);
    try {
      const params = new URLSearchParams({
        P_MATC_STATUS: editForm.status,
        P_RESERVATION_NO: String(item.Res_no),
        P_EMP_COMMENT: editForm.comment,
        P_FEEDBACK_ID: String(item.Feed_Id),
      });
      const response = await axios.get(`Reservation/AddEMPFeedback?${params}`);

      if (
        response.data &&
        (response.data.StatusCode === undefined || response.data.StatusCode === 200)
      ) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Maintenance record updated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        setEditingId(null);
        const refreshedData = await fetchMaintenanceData();
        if (refreshedData) {
          setFilteredData(
            refreshedData.filter(
              (record) => String(record.Feed_Banglowid) === selectedBungalowType
            )
          );
        }
      } else {
        throw new Error(response.data?.Message || "Failed to update maintenance record.");
      }
    } catch (error) {
      console.error("Error updating maintenance record:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update maintenance record. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
  };

  const getStatusChip = (status) => {
    const statusMap = {
      P: { color: "warning", label: "Pending" },
      C: { color: "success", label: "Completed" },
      I: { color: "secondary", label: "In Progress" },
      D: { color: "primary", label: "Complete Done" },
    };

    const { color = "default", label = "Pending" } = statusMap[status] || {};
    return <Chip label={label} color={color} size="small" />;
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 0, sm: "50%" },
          left: { xs: 0, sm: "50%" },
          transform: { xs: "none", sm: "translate(-50%, -50%)" },
          width: { xs: "100%", sm: "90%", md: "80%" },
          maxWidth: "1000px",
          height: { xs: "100dvh", sm: "auto" },
          maxHeight: { xs: "100dvh", sm: "90vh" },
          bgcolor: "background.paper",
          boxShadow: { xs: 0, sm: 24 },
          p: { xs: 2, sm: 3 },
          borderRadius: { xs: 0, sm: 3 },
          overflowY: "auto",
          outline: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2.5,
            p: { xs: 1.75, sm: 2.5 },
            pr: 6,
            borderRadius: 3,
            color: "common.white",
            background: "linear-gradient(135deg, #123b70 0%, #1976d2 100%)",
            boxShadow: "0 8px 20px rgba(25, 118, 210, 0.2)",
          }}
        >
          <Avatar sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "inherit", width: 46, height: 46 }}>
            <BuildIcon />
          </Avatar>
          <Box>
            <Typography variant={isMobile ? "h6" : "h5"} component="h2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              Maintenance Management
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: "rgba(255,255,255,0.82)" }}>
              Create and manage maintenance requests
            </Typography>
          </Box>
        </Box>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: { xs: 21, sm: 28 },
            right: { xs: 18, sm: 28 },
            color: "white",
            bgcolor: "rgba(255,255,255,0.14)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
          }}
        >
          <CloseIcon />
        </IconButton>

        {showReportForm && (
          <Paper
            elevation={0}
            sx={{
              mt: 2,
              mb: 3,
              p: { xs: 1.75, sm: 2.5 },
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
              bgcolor: "grey.50",
            }}
          >
            <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight: 700, color: "text.primary" }}>
              Report a maintenance issue
            </Typography>
            {/* <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary" }}>
              New report for reservation {MAINTENANCE_RESERVATION_NO} (status: Pending)
            </Typography> */}
            <Typography variant="caption" sx={{ display: "block", mb: 1.5, color: "text.secondary" }}>
              Reservation #{MAINTENANCE_RESERVATION_NO} · Status starts as Pending
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "stretch", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 0.5, sm: 1.5 },
              }}
            >
              <TextField
                fullWidth
                multiline
                minRows={2}
                maxRows={5}
                label="Describe the issue"
                placeholder="What needs maintenance?"
                value={maintenanceReport}
                onChange={(event) => setMaintenanceReport(event.target.value)}
                sx={{
                  flex: { xs: "0 0 auto", sm: "1 1 280px" },
                  "& .MuiOutlinedInput-root": { bgcolor: "background.paper", borderRadius: 2 },
                }}
              />
              <Button
                variant="contained"
                onClick={handleAddMaintenanceReport}
                disabled={isAddingReport || loading}
                sx={{
                  minHeight: 40,
                  minWidth: { sm: 145 },
                  whiteSpace: "nowrap",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 700,
                  boxShadow: "none",
                }}
              >
                {isAddingReport ? <CircularProgress size={20} color="inherit" /> : "Submit Report"}
              </Button>
            </Box>
          </Paper>
        )}

        {!selectedBungalowType ? (
          <Box sx={{ mt: 3, mb: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 2, textAlign: "center", color: "text.primary", fontWeight: 700 }}
            >
              Select Bungalow Type to View Maintenance
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={8} md={6}>
                {/* <Grid item xs={6} sm={6}> */}
                <Card
                  sx={{
                    cursor: "pointer",
                    borderRadius: 3,
                    border: "1px solid #dbe6f5",
                    transition: "all 0.2s ease",
                    background: "linear-gradient(145deg, #f7faff 0%, #eaf2ff 100%)",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      boxShadow: "0 10px 24px rgba(25,118,210,0.14)",
                    },
                  }}
                  onClick={() => handleBungalowSelect("1")}
                >
                  <CardContent sx={{ textAlign: "center", py: { xs: 3, sm: 4 }, px: 3 }}>
                    <Avatar
                      sx={{
                        width: 58,
                        height: 58,
                        margin: "0 auto 15px",
                        bgcolor: "#3f51b5",
                      }}
                    >
                      <HomeIcon fontSize="large" />
                    </Avatar>
                    <Typography
                      variant="h6"
                      sx={{ mb: 1, fontWeight: 700, color: "#26364b" }}
                    >
                      Main Bungalow
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        mt: 1,
                        borderRadius: 20,
                        textTransform: "none",
                        px: 2,
                        borderColor: "#3f51b5",
                        color: "#3f51b5",
                        "&:hover": {
                          backgroundColor: "#3f51b5",
                          color: "#fff",
                        },
                      }}
                    >
                      View Maintenance
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Typography
              variant="caption"
              display="block"
              sx={{ mt: 2, textAlign: "center", color: "text.secondary" }}
            >
              Click on a bungalow type to view and manage maintenance requests
            </Typography>
          </Box>
        ) : (
          <>
            <Button
              onClick={handleBackToSelection}
              sx={{ mt: 0.5, mb: 1.5, textTransform: "none", borderRadius: 2 }}
              startIcon={<ArrowBackIcon />}
              color="primary"
            >
              Back to Bungalow Selection
            </Button>

            <Typography variant="h6" sx={{ mb: 1.5, color: "text.primary", fontWeight: 700 }}>
              {selectedBungalowType === "1"
                ? "Main Bungalow"
                : "Lower Garden Suite"}{" "}
              Maintenance
            </Typography>

            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                flexDirection: "column",
                gap: 1.5,
                maxHeight: "calc(100dvh - 350px)",
                overflowY: "auto",
                pb: 1,
              }}
            >
              {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 5, gap: 1.5 }}>
                  <CircularProgress size={24} />
                  <Typography color="text.secondary">Loading maintenance requests...</Typography>
                </Box>
              ) : filteredData.length === 0 ? (
                <Paper
                  elevation={0}
                  sx={{ p: 3, textAlign: "center", border: "1px dashed", borderColor: "divider", borderRadius: 3 }}
                >
                  <Typography variant="body2" color="text.secondary">
                    No maintenance records found for this bungalow type.
                  </Typography>
                </Paper>
              ) : (
                filteredData.map((item) => (
                  <Card
                    key={`${item.Feed_Id}-${item.Res_no}`}
                    variant="outlined"
                    sx={{
                      minHeight: 190,
                      flexShrink: 0,
                      borderRadius: 3,
                      borderColor: "divider",
                      boxShadow: "0 3px 12px rgba(18,59,112,0.06)",
                    }}
                  >
                    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, mb: 1.5 }}>
                        <Typography variant="caption" color="text.secondary">
                          {item.created_date || "Date unavailable"}
                        </Typography>
                        {editingId === item.Feed_Id ? (
                          <FormControl size="small" sx={{ minWidth: 125 }}>
                            <Select
                              name="status"
                              value={editForm.status || "P"}
                              onChange={handleChange}
                              aria-label="Maintenance status"
                            >
                              <MenuItem value="C">Completed</MenuItem>
                              <MenuItem value="D">Complete Done</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          getStatusChip(item.Feed_MatStatus)
                        )}
                      </Box>
                      <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, lineHeight: 1.8 }}>
                        Maintenance report
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1.5, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                        {item.Feed_MatReport || "N/A"}
                      </Typography>
                      <Typography variant="overline" sx={{ color: "text.secondary", fontWeight: 700, lineHeight: 1.8 }}>
                        Employee comment
                      </Typography>
                      {editingId === item.Feed_Id ? (
                        <TextField
                          fullWidth
                          name="comment"
                          value={editForm.comment}
                          onChange={handleChange}
                          size="small"
                          placeholder="Enter employee comment"
                          sx={{ mt: 0.5 }}
                        />
                      ) : (
                        <Typography variant="body2" sx={{ color: "text.secondary", whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                          {item.Feed_MatComment || "No comment yet"}
                        </Typography>
                      )}
                      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5 }}>
                        {editingId === item.Feed_Id ? (
                          <>
                            <Button
                              size="small"
                              color="inherit"
                              onClick={cancelEdit}
                              startIcon={<CloseIcon />}
                              sx={{ textTransform: "none" }}
                            >
                              Cancel
                            </Button>
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleSave(item)}
                              startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <SaveIcon />}
                              disabled={loading}
                              sx={{ textTransform: "none", borderRadius: 2 }}
                            >
                              Save
                            </Button>
                          </>
                        ) : (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleEdit(item)}
                            startIcon={<EditIcon />}
                            sx={{ textTransform: "none", borderRadius: 2 }}
                          >
                            Edit
                          </Button>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                ))
              )}
            </Box>

            <Paper
              elevation={6}
              sx={{
                display: { xs: "none", sm: "block" },
                borderRadius: 1,
                width: "100%",
                overflow: "auto",
                maxHeight: "55vh",
                mt: 1,
              }}
            >
              <Box sx={{ minWidth: "50px" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#1976d2",
                        "& th": {
                          fontWeight: "bold",
                          color: "white",
                          borderRight: "1px solid rgba(255, 255, 255, 0.2)",
                          textAlign: "center",
                          padding: "6px",
                          fontSize: "11px",
                        },
                      }}
                    >
                      <TableCell>Date</TableCell>
                      {/* <TableCell>Repoter</TableCell> */}
                      <TableCell>Maintenance Report</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Employee comment</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          sx={{ textAlign: "center", py: 4 }}
                        >
                          <CircularProgress size={24} />
                          <Typography sx={{ ml: 2, display: "inline" }}>
                            Loading...
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : filteredData.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          sx={{ textAlign: "center", py: 4, color: "#666" }}
                        >
                          No maintenance records found for this bungalow type
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredData.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            backgroundColor:
                              index % 2 === 0 ? "#fafafa" : "white",
                          }}
                        >
                          <TableCell
                            sx={{
                              textAlign: "left",
                              padding: "12px",
                              fontSize: "12px",
                            }}
                          >
                            <ReadMoreText text={item.created_date || "N/A"} />
                          </TableCell>
                          {/* <TableCell
                            sx={{
                              textAlign: "left",
                              padding: "12px",
                              fontSize: "12px",
                            }}
                          >
                            <ReadMoreText
                              text={item.created_by || "N/A"}
                              wordLimit={4}
                            />
                          </TableCell> */}
                          <TableCell
                            sx={{
                              textAlign: "left",
                              padding: "12px",
                              fontSize: "12px",
                            }}
                          >
                            <Typography variant="body2">
                              <ReadMoreText
                                text={item.Feed_MatReport || "N/A"}
                                wordLimit={3}
                              />
                            </Typography>
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "center",
                              padding: "12px",
                              fontSize: "12px",
                            }}
                          >
                            {editingId === item.Feed_Id ? (
                              <FormControl fullWidth size="small">
                                <Select
                                  name="status"
                                  value={editForm.status || "P"}
                                  onChange={handleChange}
                                  displayEmpty
                                  sx={{
                                    minWidth: "120px",
                                    "& .MuiSelect-select": {
                                      py: 0.8,
                                      fontSize: "12px",
                                    },
                                  }}
                                >
                                  <MenuItem value="C">
                                    <Chip
                                      label="Completed"
                                      color="success"
                                      size="small"
                                      sx={{ mr: 1 }}
                                    />
                                  </MenuItem>
                                  <MenuItem value="D">
                                    <Chip
                                      label="Complete Done"
                                      color="primary"
                                      size="small"
                                      sx={{ mr: 1 }}
                                    />{" "}
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            ) : (
                              getStatusChip(item.Feed_MatStatus)
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "left",
                              padding: "12px",
                              fontSize: "12px",
                            }}
                          >
                            {editingId === item.Feed_Id ? (
                              <TextField
                                name="comment"
                                value={editForm.comment}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                placeholder="Enter employee comment"
                                sx={{
                                  minWidth: "150px",
                                  "& .MuiInputBase-input": {
                                    fontSize: "12px",
                                    py: 0.8,
                                  },
                                }}
                              />
                            ) : (
                              <ReadMoreText
                                text={item.Feed_MatComment || "N/A"}
                                wordLimit={20}
                              />
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: "center",
                              padding: "8px",
                              fontSize: "12px",
                            }}
                          >
                            {editingId === item.Feed_Id ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 1,
                                  justifyContent: "center",
                                }}
                              >
                                <Tooltip title="Save">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleSave(item)}
                                    sx={{
                                      backgroundColor: "#e3f2fd",
                                      "&:hover": {
                                        backgroundColor: "#bbdefb",
                                      },
                                    }}
                                  >
                                    <SaveIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={cancelEdit}
                                    sx={{
                                      backgroundColor: "#ffebee",
                                      "&:hover": {
                                        backgroundColor: "#ffcdd2",
                                      },
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            ) : (
                              <Tooltip title="Edit">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => handleEdit(item)}
                                  sx={{
                                    backgroundColor: "#e3f2fd",
                                    "&:hover": {
                                      backgroundColor: "#bbdefb",
                                    },
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Paper>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={handleClose}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  textTransform: "none",
                  fontWeight: 500,
                }}
              >
                Close
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default MaintenanceModal;
